<ng-container *ngIf="customField" style="vertical-align: middle">
  <div [ngSwitch]="customField.type" class="custom-field-input-container">
    <!-- Text Inputs -->
    <ion-input
      *ngSwitchCase="CUSTOM_FIELD_TYPES.SHORT_ANSWER"
      type="text"
      [ngModel]="value"
      (ngModelChange)="onValueChange($event)"
      placeholder="Enter text..."
      class="input-field"
    ></ion-input>
    <ion-textarea
      *ngSwitchCase="CUSTOM_FIELD_TYPES.LONG_ANSWER"
      [ngModel]="value"
      (ngModelChange)="onValueChange($event)"
      placeholder="Enter text..."
      autoGrow="true"
      class="input-field"
    ></ion-textarea>

    <!-- Date Input -->
    <!-- Assuming value is stored as ISO string e.g., YYYY-MM-DD -->
    <ion-input
      *ngSwitchCase="CUSTOM_FIELD_TYPES.DATE"
      type="date"
      [ngModel]="value"
      (ngModelChange)="onValueChange($event)"
      class="input-field"
    ></ion-input>

    <!-- Checkbox / Toggle -->
    <ion-item
      *ngSwitchCase="CUSTOM_FIELD_TYPES.CHECKBOX"
      lines="none"
      class="automation-toggle-item"
    >
      <ion-toggle
        [ngModel]="value"
        (ionChange)="onValueChange($event)"
        slot="start"
      >
      </ion-toggle>
      <ion-label>{{ value ? "Checked" : "Unchecked" }}</ion-label>
    </ion-item>

    <!-- Internal Single/Multi Select -->
    <ion-select
      *ngIf="
        !customField.externalSelect &&
        (customField.type === CUSTOM_FIELD_TYPES.SINGLE_SELECT ||
          customField.type === CUSTOM_FIELD_TYPES.MULTI_SELECT)
      "
      [ngModel]="value"
      (ngModelChange)="onValueChange($event)"
      [placeholder]="
        customField.type === CUSTOM_FIELD_TYPES.SINGLE_SELECT
          ? 'Select option...'
          : 'Select options...'
      "
      interface="popover"
      [multiple]="customField.type === CUSTOM_FIELD_TYPES.MULTI_SELECT"
      class="select-outline"
      [compareWith]="areValuesEqual"
    >
      <!-- Add None option only for single select -->
      <ion-select-option
        *ngIf="customField.type === CUSTOM_FIELD_TYPES.SINGLE_SELECT"
        [value]="null"
        >None</ion-select-option
      >
      <ion-select-option
        *ngFor="let option of customField.options; trackBy: trackByUniqueId"
        [value]="option"
      >
        {{ option }}
      </ion-select-option>
    </ion-select>

    <!-- User Select (Single) -->
    <ion-button
      *ngSwitchCase="CUSTOM_FIELD_TYPES.USER_SELECT"
      fill="clear"
      color="primary"
      class="filter-label"
      (click)="openUserSelectPopover()"
    >
      {{ getDisplayValue(value) }}
      <ion-icon
        name="caret-down-outline"
        slot="end"
        style="font-size: 0.7rem; color: var(--ion-color-primary)"
      ></ion-icon>
    </ion-button>

    <!-- User Select (Multi) -->
    <div
      *ngSwitchCase="CUSTOM_FIELD_TYPES.MULTI_USER_SELECT"
      style="font-weight: 500"
    >
      <ion-chip
        *ngFor="let user of value; trackBy: trackByUniqueId"
        mode="ios"
        class="chip tag-chip"
        color="primary"
        (click)="removeValue(user)"
      >
        <ion-label>{{ getChipDisplayValue(user) }}</ion-label>
      </ion-chip>
      <ion-chip
        mode="ios"
        style="border: none !important"
        class="chip tag-chip"
        (click)="openUserSelectPopover(true)"
      >
        <ion-label>
          <span>Add...</span>
        </ion-label>
      </ion-chip>
    </div>

    <!-- User Group Select (Single) -->
    <ion-button
      *ngSwitchCase="CUSTOM_FIELD_TYPES.USER_GROUP_SELECT"
      fill="clear"
      color="primary"
      class="filter-label"
      (click)="openUserGroupSelectPopover()"
    >
      {{ getDisplayValue(value) }}
      <ion-icon name="caret-down-outline" slot="end"></ion-icon>
    </ion-button>

    <!-- User Group Select (Multi) -->
    <div
      *ngSwitchCase="CUSTOM_FIELD_TYPES.MULTI_USER_GROUP_SELECT"
      style="font-weight: 500"
    >
      <ion-chip
        *ngFor="let group of value; trackBy: trackByUniqueId"
        mode="ios"
        color="primary"
        class="chip tag-chip"
        (click)="removeValue(group)"
      >
        <ion-label>{{ getChipDisplayValue(group) }}</ion-label>
        <ion-icon name="close-circle"></ion-icon>
      </ion-chip>
      <ion-chip
        mode="ios"
        style="border: none !important"
        class="chip tag-chip"
        (click)="openUserGroupSelectPopover(true)"
      >
        <ion-label>
          <span>Add...</span>
        </ion-label>
      </ion-chip>
    </div>

    <!-- External Select (Single) -->
    <ion-button
      *ngIf="
        customField.type === CUSTOM_FIELD_TYPES.SINGLE_SELECT &&
        customField.externalSelect
      "
      fill="clear"
      color="dark"
      class="filter-label"
      (click)="openExternalSelectPopover()"
    >
      {{ getDisplayValue(value) }}
      <ion-icon
        name="caret-down-outline"
        slot="end"
        style="font-size: 0.7rem; color: var(--ion-color-primary)"
      ></ion-icon>
    </ion-button>

    <!-- External Select (Multi) -->
    <div
      *ngIf="
        customField.type === CUSTOM_FIELD_TYPES.MULTI_SELECT &&
        customField.externalSelect
      "
    >
      <ion-chip
        *ngFor="let item of value; trackBy: trackByUniqueId"
        mode="ios"
        color="primary"
        class="chip tag-chip"
        (click)="removeValue(item)"
      >
        <ion-label>{{ getChipDisplayValue(item) }}</ion-label>
        <ion-icon
          name="close-outline"
          style="font-size: 0.7rem; color: var(--ion-color-primary)"
        ></ion-icon>
      </ion-chip>
      <ion-chip
        mode="ios"
        style="border: none !important"
        class="chip tag-chip"
        (click)="openExternalSelectPopover(true)"
      >
        <ion-label>
          <span style="font-weight: 500">Add...</span>
        </ion-label>
      </ion-chip>
    </div>
  </div>
</ng-container>
